import React, { useEffect, useState } from "react";
import DashboardLayout from "@layouts/dashboard/dashboard-layout";
import { getValue, setValue } from "@utils/lodash";
//import { adminGetUsers } from '@services/users.service';
import { NavLink } from "react-router-dom";
//import moment from 'moment';
import {
  adminDeleteSpecificCheckpoint,
  GetCheckpointPECompliance,
  UpdateBulkStatusCheckpointPECompliance,
} from "@services/checkpoint.service";
import { useNavigate } from "react-router-dom";
import FilterForm from "@components/common/AddFilter/FilterForm";
import NavigationBar from "@components/NotificationBar";
import DeleteModal from "@_common/deleteModal";
import { toast } from "react-toastify";
import PaginationPage from "@components/pagination/pagination";
import SearchHeader from "@components/common/SearchHeader";
import {
  adminGetCountriesListManagement,
  adminGetListManagementGroupCode,
  adminGetStatesListManagement,
  getSmartFilterCategoryOfLawList,
  getSmartFilterLegislationList,
  getSmartFilterLegislationRuleList,
  getSmartFilterListManagementList,
} from "@services/list-management.service";
import Notfound from "@components/Not-Found";
import Loader from "@components/common/Loader";
import ConfigurePopup from "./popup/configure-popup";
import { QueryRequestHelper } from "@_common/query-request-helper";
import NoAccessPage from "@components/common/NoAccess";
import { Button } from "reactstrap";
import { clientGetLocation } from "@services/location.service";
import ScrollableReactTable from "@components/ScrollableDatatable";
import FooterWrapper from "@components/common/FooterWrapper";
import MenuRepositorySvgComponent from "../../../assets/svg-components/left-menu/menurepo";
import RightMenuHeaders from "@components/common/RightMenuHeaders";
import CheckpointLicenseNotfound from "@components/Page-Not-Found/checkpoint-license-not-found";
import ModuleFilter from "@components/common/ModuleFilter";
import { getSpecificCategoryLawById } from "@_common/global-apis";
import { countKeysWithValues } from "@_common/text-helpers";
import SubmenuArrowDownSvgComponent from "../../../assets/svg-components/left-menu/submenu-arrow-down";

interface IPEComplianceProps {}

const ClientPECompliance: React.FunctionComponent<IPEComplianceProps> = (
  props: any
) => {
  let navigate = useNavigate();

  /* -------------------------------------------------------------------------- */
  /*                               UseState Section                             */
  /* -------------------------------------------------------------------------- */

  const [isLoading, setIsLoading] = React.useState(true);
  const [list, setList] = React.useState<[]>([]);
  const [isFilterVisible, setFilterVisibility] = React.useState(false);

  const [isOpen, setIsOpen] = useState(false);
  const handleModal = () => {
    setIsOpen(!isOpen);
  };
  const handleModalCancel = () => {
    handleModal();
  };

  const [filterIsOpen, setFilterIsOpen] = useState(false);

  const handleFilter = () => {
    setFilterIsOpen(!filterIsOpen);
  };

  /* -------------------------------------------------------------------------- */
  /*                               UseEffect Section                            */
  /* -------------------------------------------------------------------------- */

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (Object.keys(params).length === 0 && props.permissionAPITriggered) {
      getData();
      getSmartFilterList();
      getCountriesList();
      getLocations("", "");
      getFrequency("", "");

      getCategoryLawList("", "", "");
      getLegislationList("", "", "");
      getLegislationRuleList("", "", "");
    }
  }, [props.permissionAPITriggered]);

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (Object.keys(params).length > 0 && props.permissionAPITriggered) {
      getData();
      getCountriesList();
      if (params.page_no) {
        setPage_no(parseInt(params.page_no));
      }
      if (params.search_text) {
        setSearchInput(params.search_text);
        setShowSearchTextbox(true);
      }
      if (params.limit) {
        setLimit(parseInt(params.limit));
      }
      if (getValue(params, `smart_filter_tags`, "")) {
        getSmartFilterList();
        // getLegislationRuleList(getValue(params, `legislation_id`, ""));
      } else {
        getSmartFilterList();
      }

      if (getValue(params, `location_id`, "")) {
        getLocations(getValue(params, `location_id`, ""), "");
      } else {
        getLocations("", "");
      }
      if (getValue(params, `frequency_id`, "")) {
        getFrequency(getValue(params, `frequency_id`, ""), "");
      } else {
        getFrequency("", "");
      }
      setRequest({
        country_id: getValue(params, `country_id`, ""),
        state_id: getValue(params, `state_id`, ""),
        category_of_law_id: getValue(params, `category_of_law_id`, ""),
        legislation_id: getValue(params, `legislation_id`, ""),
        legislation_rule_id: getValue(params, `legislation_rule_id`, ""),
        event_id: getValue(params, `event_id`, ""),
        sub_event_id: getValue(params, `sub_event_id`, ""),
      });
      if (getValue(params, `country_id`, "")) {
        setFilterVisibility(true);
        getStatesList(getValue(params, `country_id`, ""));
      }
      if (
        getValue(params, `state_id`, "") ||
        getValue(params, `category_of_law_id`, "") ||
        getValue(params, `legislation_id`, "")
      ) {
        getCategoryLawList(
          "",
          getValue(params, `state_id`, ""),
          getValue(params, `category_of_law_id`, "")
        );
        getLegislationList(
          "",
          getValue(params, `state_id`, ""),
          getValue(params, `legislation_id`, "")
        );
        getLegislationRuleList(
          "",
          getValue(params, `legislation_id`, ""),
          getValue(params, `legislation_rule_id`, "")
        );
      } else {
        getCategoryLawList("", "", "");
        getLegislationList("", "", "");
        getLegislationRuleList("", "", "");
      }
      if (getValue(params, `smart_filter_tags`, "")) {
        getSmartFilterList();
        // getLegislationRuleList(getValue(params, `legislation_id`, ""));
      }
    }
  }, [window.location.href, props.permissionAPITriggered]);

  const [smartFilterList, setSmartFilterList] = useState([]);
  const [selectedSmartFilterIds, setSelectedSmartFilterIds] = useState<any>([]);
  const handleChangeSelectMulti = (e: any) => {
    setSelectedSmartFilterIds(e);
  };
  const getSmartFilterList = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    let selectedIDs: any = urlSearchParams.getAll("smart_filter_tags[]");

    try {
      let resp = await adminGetListManagementGroupCode("smart-filter");
      if (resp) {
        let list =
          getValue(resp, `data.listItems.length`, 0) > 0
            ? getValue(resp, `data.listItems`, []).filter((item: object) =>
                getValue(item, `is_active`, "")
              )
            : [];
        let obj = list.map((item: object) => ({
          id: getValue(item, `id`, ""),
          is_active: getValue(item, `is_active`, ""),
          text: getValue(item, `text`, ""),
          value: getValue(item, `text`, ""),
          label: getValue(item, `text`, ""),
        }));
        setSmartFilterList(obj);
        if (getValue(selectedIDs, `length`, 0) > 0) {
          let arr: [] | any = [];
          selectedIDs.map((item: object) => {
            let filtered =
              getValue(obj, `length`, 0) > 0 &&
              obj.filter((ob: any) => ob.id == item);
            if (getValue(filtered, `length`, 0) > 0) {
              arr.push(filtered[0]);
            }
          });
          setSelectedSmartFilterIds(arr);
        }
      } else {
      }
    } catch (error) {}
  };

  /* -------------------------------------------------------------------------- */
  /*                               API Section                                  */
  /* -------------------------------------------------------------------------- */

  const getData = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let selectedIDs: any = urlSearchParams.getAll("smart_filter_tags[]");

    let payload: any = {
      page_no: params.page_no ? parseInt(params.page_no) : 1,
      page_size: params.limit ? parseInt(params.limit) : limit,
      search_text: params.search_text,
      status: "active",
      sort_by: params.sort_by,
      country_id: getValue(params, `country_id`, ""),
      state_id: getValue(params, `state_id`, ""),
      category_of_law_id: await getSpecificCategoryLawById(
        getValue(params, `category_of_law_id`, "")
      ),
      legislation_id: getValue(params, `legislation_id`, ""),
      frequency_id: getValue(params, `frequency_id`, ""),
      legislation_rule_id: getValue(params, `legislation_rule_id`, ""),
      event_id: getValue(params, `event_id`, ""),
      sub_event_id: getValue(params, `sub_event_id`, ""),
      smart_filter_tags: selectedIDs,
      is_configured: getValue(params, `is_configured`, ""),
      location_id: getValue(params, `location_id`, ""),
      compliance_type_id: getValue(params, `compliance_type_id`, ""),
    };
    let queryRequest = QueryRequestHelper(payload);

    try {
      setIsLoading(true);
      let resp = await GetCheckpointPECompliance(queryRequest);
      // let resp = await adminGetUsers(queryRequest);
      if (resp) {
        setList(
          getValue(resp, `data.pe_compliances`, []).map((item: object) => ({
            ...item,
            category_of_lawName: getValue(
              item,
              `checkpoint.category_of_law.text`,
              ""
            ),
            compliance_typeName: getValue(
              item,
              `checkpoint.compliance_type.text`,
              ""
            ),
            frequency_name: getValue(item, `checkpoint.frequency.text`, ""),
            legislation_name: getValue(
              item,
              `checkpoint.legislation.legislation_name`,
              ""
            ),
            legislation_ruleName: getValue(
              item,
              `checkpoint.legislation_rule.rule_name`,
              ""
            ),
            compliance_activity: getValue(
              item,
              `checkpoint.compliance_activity`,
              ""
            ),
            form_no: getValue(item, `checkpoint.form_no`, ""),
            checkpoint_id: getValue(item, `checkpoint.checkpoint_id`, ""),
            function_name: getValue(item, `function.function_name`, ""),
            location_name: getValue(item, `location.location_name`, ""),
            status: getValue(item, `is_active`, false) ? "Active" : "Inactive",
            is_configured: getValue(item, `is_configured`, false)
              ? "Configured"
              : "Not Configured",

            smart_filter_tags: selectedIDs,
          }))
        );
        setTotalCount(getValue(resp, `data.pagination.total`, 0));
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };
  const getDataRefetch = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let selectedIDs: any = urlSearchParams.getAll("smart_filter_tags[]");

    let payload: any = {
      page_no: params.page_no ? parseInt(params.page_no) : 1,
      page_size: params.limit ? parseInt(params.limit) : limit,
      search_text: params.search_text,
      status: "active",
      sort_by: params.sort_by,
      country_id: getValue(params, `country_id`, ""),
      state_id: getValue(params, `state_id`, ""),
      category_of_law_id: await getSpecificCategoryLawById(
        getValue(params, `category_of_law_id`, "")
      ),
      frequency_id: getValue(params, `frequency_id`, ""),
      legislation_id: getValue(params, `legislation_id`, ""),
      legislation_rule_id: getValue(params, `legislation_rule_id`, ""),
      event_id: getValue(params, `event_id`, ""),
      sub_event_id: getValue(params, `sub_event_id`, ""),
      smart_filter_tags: selectedIDs,
      is_configured: getValue(params, `is_configured`, ""),
      location_id: getValue(params, `location_id`, ""),
      compliance_type_id: getValue(params, `compliance_type_id`, ""),
    };
    let queryRequest = QueryRequestHelper(payload);

    try {
      let resp = await GetCheckpointPECompliance(queryRequest);
      // let resp = await adminGetUsers(queryRequest);
      if (resp) {
        setList(
          getValue(resp, `data.pe_compliances`, []).map((item: object) => ({
            ...item,
            category_of_lawName: getValue(
              item,
              `checkpoint.category_of_law.text`,
              ""
            ),
            compliance_typeName: getValue(
              item,
              `checkpoint.compliance_type.text`,
              ""
            ),
            frequency_name: getValue(item, `checkpoint.frequency.text`, ""),
            legislation_name: getValue(
              item,
              `checkpoint.legislation.legislation_name`,
              ""
            ),

            compliance_activity: getValue(
              item,
              `checkpoint.compliance_activity`,
              ""
            ),
            form_no: getValue(item, `checkpoint.form_no`, ""),
            legislation_ruleName: getValue(
              item,
              `checkpoint.legislation_rule.rule_name`,
              ""
            ),
            checkpoint_id: getValue(item, `checkpoint.checkpoint_id`, ""),
            function_name: getValue(item, `function.function_name`, ""),
            location_name: getValue(item, `location.location_name`, ""),
            status: getValue(item, `is_active`, false) ? "Active" : "Inactive",
            is_configured: getValue(item, `is_configured`, false)
              ? "Configured"
              : "Not Configured",

            smart_filter_tags: selectedIDs,
          }))
        );
        setTotalCount(getValue(resp, `data.pagination.total`, 0));
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  /* ---------------------------  Location Section ------------------------------------ */

  const [locationList, setLocationList] = useState([]);
  const [searchLoading, setSearchLoading] = useState(false);
  const handleTriggerLocation = (value: string) => {
    if (value) {
      getLocations("", value);
    } else {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());
      delete params.location_id;
      let payload = {
        ...params,
        page_no: 1,
      };
      let queryRequest = QueryRequestHelper(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
    }
  };
  const getLocations = async (id: string, value: string) => {
    try {
      let payload: any = {
        page_no: 1,
        page_size: 10,
        is_active: true,
        search_text: value,
        id: id,
      };
      let queryRequest = QueryRequestHelper(payload);
      setSearchLoading(true);
      let resp = await clientGetLocation(queryRequest);
      if (resp) {
        let filtered =
          getValue(resp, `data.locations.length`, 0) > 0 &&
          getValue(resp, `data.locations`, []).filter((item: object) =>
            getValue(item, `is_active`, false)
          );
        setSearchLoading(false);
        setLocationList(
          getValue(filtered, `length`, 0) > 0 &&
            filtered.map((item: object) => ({
              ...item,
              status: getValue(item, `is_active`, false)
                ? "Active"
                : "Inactive",
              city_name: getValue(item, `city.name`, ""),
              value: getValue(item, `location_name`, ""),
              label: getValue(item, `location_name`, ""),
            }))
        );
      } else {
        setSearchLoading(false);
      }
    } catch (error) {
      setSearchLoading(false);
    }
  };
  /* ---------------------------  Frequency Section ------------------------------------ */

  const [frequencyList, setFrequencyList] = useState([]);
  const [searchFrequencyLoading, setSearchFrequencyLoading] = useState(false);
  const handleTriggerFrequency = (value: string) => {
    if (value) {
      getFrequency("", value);
    } else {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());
      delete params.frequency_id;
      let payload = {
        ...params,
        page_no: 1,
      };
      let queryRequest = QueryRequestHelper(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
    }
  };
  const getFrequency = async (id: string, value: string) => {
    try {
      let payload: any = {
        page_no: 1,
        page_size: 10,
        is_active: true,
        search_text: value,
        id: id,
        group_code: "frequency",
      };
      let queryRequest = QueryRequestHelper(payload);
      setSearchFrequencyLoading(true);
      let resp = await getSmartFilterListManagementList(queryRequest);
      if (resp) {
        setSearchFrequencyLoading(false);
        setFrequencyList(
          getValue(resp, `data.listItems`, []).map((item: object) => ({
            ...item,
            value: getValue(item, `text`, ""),
            label: getValue(item, `text`, ""),
          }))
        );
      } else {
        setSearchFrequencyLoading(false);
      }
    } catch (error) {
      setSearchFrequencyLoading(false);
    }
  };

  /* -------------------------------------------------------------------------- */
  /*                               Search section                               */
  /* -------------------------------------------------------------------------- */
  const [showSearchTextbox, setShowSearchTextbox] = useState(false);
  const [search_text, setSearchInput] = useState<any>("");

  const toggleSearch = () => {
    setShowSearchTextbox((prevState) => !prevState);
  };
  const toggleSearchClose = () => {
    setSearchInput("");
    toggleSearch();
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (params.search_text) {
      delete params.search_text;
      let payload: any = { ...params };
      // removing null values
      let queryRequest = QueryRequestHelper(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
      getData();
    }
  };

  const handleChangeSearch = async (e: any) => {
    setSearchInput(e.target.value);
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      ...params,
      page_no: 1,
      search_text: e.target.value,
    };
    let queryRequest = QueryRequestHelper(payload);

    navigate(`${window.location.pathname}?${queryRequest}`);
    if (!e.target.value) {
      getData();
    }
  };

  const [selectedIDs, setSelectedIDs] = useState<any>([]);
  const getTableState = (value: object) => {
    let selectedIndexList = Object.keys(
      getValue(value, `selectedRowIds`, {})
    ).map((item) => parseInt(item));
    let selectedIds =
      list.length > 0
        ? list.filter((_item: object, index: number) =>
            selectedIndexList.includes(index)
          )
        : [];
    if (selectedIds.length > 0) {
      setSelectedIDs(
        selectedIds.map((item: object) => getValue(item, `id`, ""))
      );
    } else {
      setSelectedIDs([]);
    }
  };

  /* -------------------------------------------------------------------------- */
  /*                                 Delete section                             */
  /* -------------------------------------------------------------------------- */

  const [deleteValue, setDeleteValue] = useState("");
  const [deleteId, setDeleteId] = useState("");
  const handleDeleteFun = (id: string, value: string) => {
    setDeleteValue(value);
    setDeleteId(id);
    handleDelete();
  };
  const [isDelete, setIsDelete] = useState(false);
  const handleDelete = () => {
    setIsDelete(!isDelete);
  };

  const handleDeleteFunction = async () => {
    try {
      let resp = await adminDeleteSpecificCheckpoint(deleteId);
      if (resp) {
        toast.success(getValue(resp, `message`, ""));
        handleDelete();
        getData();
      }
    } catch (error) {}
  };

  /* -------------------------------------------------------------------------- */
  /*                               Onchange section                             */
  /* -------------------------------------------------------------------------- */

  const handleChangeSortBy = (value: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    params.sort_by = value;
    props.history.push({
      pathname: window.location.pathname,
      query: params,
    });
  };

  const handleChangeStatus = (name: string, value: string) => {
    if (value) {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());
      let payload = {
        ...params,
        [name]: value,
        page_no: 1,
      };
      let queryRequest = QueryRequestHelper(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
    } else {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());
      let payload = {
        ...params,
        [name]: "",
        page_no: 1,
      };
      let queryRequest = QueryRequestHelper(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
    }
  };

  const [configureID, setConfigureID] = useState<string>("");
  const handleEditPopup = (id: string) => {
    if (id) {
      setIsOpen(!isOpen);
      setConfigureID(id);
    }
  };
  /* -------------------------------------------------------------------------- */
  /*                               Pagination section                           */
  /* -------------------------------------------------------------------------- */

  const [totalCount, setTotalCount] = useState(0);
  const [limit, setLimit] = useState(100);
  const [page_no, setPage_no] = useState(1);

  const handleChangePagination = (page_no: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload = {
      ...params,
      page_no: page_no,
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
  };

  const handleChangeLimit = (limit: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      ...params,
      limit: limit,
      page_no: "1",
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
  };
  const rowClick = (obj: object) => {
    // console.log(getValue(obj,`original`,''))
    // navigate(`/support/detail/${getValue(obj,`original.id`,'')}`)
  };
  const getTrProps = (rowInfo: any) => {
    if (getValue(rowInfo, `id`, "")) {
      return {
        style: {
          //   background:  'red',
          //   color: 'black'
        },
      };
    }
    return {};
  };
  const columns = React.useMemo(
    () => [
      {
        Header: "Checkpoint ID",
        accessor: "checkpoint_id",
        width: 100,
        Cell: ({ row }: any) => {
          return <NavLink to={`#`}>{row.values.checkpoint_id}</NavLink>;
        },
      },
      {
        Header: "Legislation",
        accessor: "legislation_name",
        width: 350,
      },
      // {
      //   Header: "Compliance Activity",
      //   accessor: "compliance_activity",
      //   width: 450,
      // },
      {
        Header: "Activity",
        accessor: "compliance_activity",
        width: 370,
        Cell: ({ row }) => {
          const complianceActivity = getValue(
            row.original,
            `compliance_activity`,
            ""
          );
      
          const maxCharCount = 100;
          const [showFullContent, setShowFullContent] = useState(false);
      
          const toggleContent = (e:any) => {
            e.stopPropagation();
            setShowFullContent(!showFullContent);
          };
      
          const truncatedContent = complianceActivity
          ? complianceActivity.slice(0, maxCharCount)
          : "";
          return (
            <div>
              {showFullContent ? complianceActivity : truncatedContent}
              {getValue(complianceActivity, `length`, 0) > maxCharCount && (
                <span onClick={toggleContent}>
                {showFullContent ? <span style={{color:"#276ef1"}}> View less <span style={{ transform: "rotate(180deg)", display: "inline-block"}}> <SubmenuArrowDownSvgComponent color="#276ef1" /> </span></span> : <span> ... <span style={{color:"#276ef1"}}>View more <SubmenuArrowDownSvgComponent color="#276ef1" /> </span></span>}
                </span>
              )}
            </div>
          );
        }
      },
      {
        Header: "Form Name",
        accessor: "form_no",
        width: 200,
      },
      {
        Header: "Frequency",
        accessor: "frequency_name",
        width: 100,
      },
      // {
      // 	Header: "Compliance Type",
      // 	accessor: "compliance_typeName",
      // 	width: 250,
      // },

      // {
      // 	Header: "Rule",
      // 	accessor: "legislation_ruleName",
      // 	width: 250,
      // },
      // {
      // 	Header: "Frequency",
      // 	accessor: "frequency_name",
      // 	width: 250,
      // },
      {
        Header: "Location",
        accessor: "location_name",
        width: 150,
      },
      {
        Header: "Function",
        accessor: "function_name",
        width: 120,
      },
      {
        Header: "Status",
        accessor: "status",
        width: 80,
      },
      {
        Header: "Action",
        width: 150,
        Cell: ({ row }: any) => {
          return (
            <>
              <Button
                color="none"
                style={{
                  color:
                    getValue(row, `original.is_configured`, "") === "Configured"
                      ? "#0d6efd"
                      : "black",
                  fontSize: "12px",
                }}
                onClick={() =>
                  handleEditPopup(
                    getValue(row, `original.is_configured`, "") === "Configured"
                      ? row.original.id
                      : ""
                  )
                }
              >
                {getValue(row, `original.is_configured`, "") === "Configured"
                  ? "Configured"
                  : "Not Configured"}
              </Button>
            </>
          );
        },
      },
    ],
    []
  );

  /* -------------------------------------------------------------------------- */
  /*                                  Smart Filters                             */
  /* -------------------------------------------------------------------------- */
  const [request, setRequest] = useState<any>({
    country_id: "101",
    state_id: "",
    category_of_law_id: "",
    legislation_id: "",
    legislation_rule_id: "",
  });
  useEffect(() => {
    getStatesList(request.country_id);
  }, [request.country_id]);

  const [countryList, setCountryList] = useState([]);
  const [states, setStates] = useState([]);

  const reset = () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      page_no: params.page_no,
      search_text: getValue(params, `search_text`, ""),
      limit: getValue(params, `limit`, ""),
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
    getData();
    reset1();
  };
  const [resetInput, setResetInput] = useState(false);
  const reset1 = () => {
    setRequest({
      ...request,
      // country_id: "",
      state_id: "",
      category_of_law_id: "",
      legislation_id: "",
      legislation_rule_id: "",
    });
    setSelectedSmartFilterIds([]);
    setResetInput(true);
  };

  const getCountriesList = async () => {
    try {
      let resp = await adminGetCountriesListManagement();
      if (resp) {
        setCountryList(
          getValue(resp, `data.countries`, []).map((item: object) => ({
            ...item,
            value: getValue(item, `name`, ""),
            label: getValue(item, `name`, ""),
          }))
        );
      } else {
      }
    } catch (error) {}
  };

  const getStatesList = async (countryId: number) => {
    if (countryId) {
      try {
        let resp = await adminGetStatesListManagement(countryId);
        if (resp) {
          setStates(
            getValue(resp, `data.states`, []).map((item: object) => ({
              ...item,
              value: getValue(item, `name`, ""),
              label: getValue(item, `name`, ""),
            }))
          );
        } else {
        }
      } catch (error) {}
    }
  };

  /* ---------------------------  Category Of Law  ----------------------------- */
  const [categoryOfLawList, setCategoryOfLawList] = useState([]);
  const [categoryLawLoading, setCategoryLawLoading] = useState(false);
  const getCategoryLawList = async (
    value: string,
    state_id: string,
    id: string
  ) => {
    try {
      setResetInput(false);
      setCategoryLawLoading(true);
      let payload = {
        page_no: 1,
        page_size: 10,
        search_text: value,
        state_id: state_id ? state_id : getValue(request, `state_id`, ""),
        // state_id: state_id,
        id: id,
      };
      let queryRequest = QueryRequestHelper(payload);
      let resp = await getSmartFilterCategoryOfLawList(queryRequest);
      if (resp) {
        setCategoryOfLawList(
          getValue(resp, `data.stateCategoryOfLaw`, []).map((item: object) => ({
            // ...item,
            // id: getValue(item, `category_of_law.id`, ""),
            id: getValue(item, `id`, ""),
            value: getValue(item, `category_of_law.text`, ""),
            label: getValue(item, `category_of_law.text`, ""),
          }))
        );
        setCategoryLawLoading(false);
        setValue(request, `category_of_law_id`, "");
      } else {
        setCategoryLawLoading(false);
      }
    } catch (error) {
      setCategoryLawLoading(false);
    }
    if (!value) {
      setValue(request, `category_of_law_id`, "");
    }
  };

  /* ---------------------------  Legislation  ----------------------------- */
  const [legislationList, setLegislationList] = useState([]);
  const [legislationLoading, setLegislationLoading] = useState(false);
  const getLegislationList = async (
    value: string,
    state_id: string,
    id: string
  ) => {
    try {
      setResetInput(false);
      setLegislationLoading(true);
      let payload = {
        page_no: 1,
        page_size: 10,
        search_text: value,
        state_id: state_id ? state_id : getValue(request, `state_id`, ""),
        // state_id: state_id,
        id: id,
      };
      let queryRequest = QueryRequestHelper(payload);
      let resp = await getSmartFilterLegislationList(queryRequest);
      if (resp) {
        setLegislationList(
          getValue(resp, `data.legislations`, []).map((item: object) => ({
            ...item,
            value: getValue(item, `legislation_name`, ""),
            label: getValue(item, `legislation_name`, ""),
          }))
        );
        setLegislationLoading(false);
        setValue(request, `legislation_id`, "");
      } else {
        setLegislationLoading(false);
      }
    } catch (error) {
      setLegislationLoading(false);
    }
    if (!value) {
      setValue(request, `legislation_id`, "");
    }
  };

  /* ---------------------------  Legislation Rule  ----------------------------- */
  const [ruleList, setRuleList] = useState([]);
  const [legislationRuleLoading, setLegislationRuleLoading] = useState(false);
  const getLegislationRuleList = async (
    value: string,
    legislation_id: string,
    id: string
  ) => {
    try {
      setResetInput(false);
      setLegislationRuleLoading(true);
      let payload = {
        page_no: 1,
        page_size: 10,
        search_text: value,
        legislation_id: legislation_id
          ? legislation_id
          : getValue(request, `legislation_id`, ""),
        id: id,
      };
      let queryRequest = QueryRequestHelper(payload);
      let resp = await getSmartFilterLegislationRuleList(queryRequest);
      if (resp) {
        setRuleList(
          getValue(resp, `data.legislationRules`, []).map((item: object) => ({
            ...item,
            value: getValue(item, `rule_name`, ""),
            label: getValue(item, `rule_name`, ""),
          }))
        );
        setLegislationRuleLoading(false);
        setValue(request, `legislation_rule_id`, "");
      } else {
        setLegislationRuleLoading(false);
      }
    } catch (error) {
      setLegislationRuleLoading(false);
    }
    if (!value) {
      setValue(request, `legislation_rule_id`, "");
    }
  };

  /* ---------------------------  Onchange Smart filter  ----------------------------- */

  const handleChangeSelect = (e: any, type: string) => {
    if (type === "country_id") {
      getStatesList(e.id);
      setStates([]);
      setCategoryOfLawList([]);
      setLegislationList([]);
      setRuleList([]);
      setRequest({
        ...request,
        country_id: e.id,
        state_id: "",
        category_of_law_id: "",
        legislation_id: "",
        legislation_rule_id: "",
      });
    }
    if (type === "state_id") {
      if (!getValue(e, `id`, "")) {
        setValue(request, `state_id`, "");
        setRequest({
          ...request,
          // state_id: "",
          category_of_law_id: "",
          legislation_id: "",
          legislation_rule_id: "",
        });
        getCategoryLawList("", "", "");
        getLegislationList("", "", "");
        getLegislationRuleList("", "", "");
      } else {
        setRequest({
          ...request,
          state_id: getValue(e, `id`, "") ? e.id : "",
          category_of_law_id: "",
          legislation_id: "",
          legislation_rule_id: "",
        });
        getCategoryLawList("", e.id, "");
        getLegislationList("", e.id, "");
        setCategoryOfLawList([]);
        setLegislationList([]);
        setRuleList([]);
      }
    }
    if (type === "category_of_law_id") {
      setRequest({
        ...request,
        category_of_law_id: getValue(e, `id`, "") ? e.id : "",
      });
    }
    if (type === "legislation_id") {
      getLegislationRuleList("", getValue(e, `id`, "") ? e.id : "", "");
      setRequest({
        ...request,
        legislation_id: getValue(e, `id`, "") ? e.id : "",
        legislation_rule_id: "",
      });
    }
    if (type === "legislation_rule_id") {
      setRequest({
        ...request,
        legislation_rule_id: getValue(e, `id`, "") ? e.id : "",
      });
    }
    if (type === "frequency_id") {
      setRequest({
        ...request,
        frequency_id: getValue(e, `id`, "") ? e.id : "",
      });
    }
    if (type === "checkpoint_id") {
      setRequest({
        ...request,
        checkpoint_id: getValue(e, `id`, "") ? e.id : "",
      });
    }
    if (type === "event_id") {
      setRequest({
        ...request,
        event_id: getValue(e, `id`, "") ? e.id : "",
      });
    }
    if (type === "sub_event_id") {
      setRequest({
        ...request,
        sub_event_id: getValue(e, `id`, "") ? e.id : "",
      });
    }
  };
  const handleSubmitSmartFilter = () => {
    let selectedSmartFilterIdsPayload = JSON.parse(
      JSON.stringify(selectedSmartFilterIds)
    );
    if (
      getValue(request, `country_id`, "")
      // getValue(request, `state_id`, "")
      // && getValue(request, `category_of_law_id`, "") &&
      // getValue(request, `legislation_id`, "") &&
      // getValue(request, `legislation_rule_id`, "")
    ) {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());
      let payload: any = {
        ...params,
        page_no: params.page_no,
        country_id: getValue(request, `country_id`, ""),
        state_id: getValue(request, `state_id`, ""),
        category_of_law_id: getValue(request, `category_of_law_id`, ""),
        legislation_id: getValue(request, `legislation_id`, ""),
        legislation_rule_id: getValue(request, `legislation_rule_id`, ""),
        search_text: getValue(params, `search_text`, ""),
        limit: getValue(params, `limit`, ""),
        smart_filter_tags:
          selectedSmartFilterIdsPayload.length > 0
            ? selectedSmartFilterIdsPayload.map((item: object) =>
                getValue(item, `id`, "")
              )
            : [],
      };
      let queryRequest = QueryRequestHelper(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
      handleFilter();
    } else {
      toast.error("All fields are mandatory");
    }
  };

  let country_ID =
    getValue(countryList, `length`, 0) > 0 &&
    countryList.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `country_id`, "")
    );
  let state_ID =
    getValue(states, `length`, 0) > 0 &&
    states.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `state_id`, "")
    );
  let cat_ID =
    getValue(categoryOfLawList, `length`, 0) > 0 &&
    categoryOfLawList.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `category_of_law_id`, "")
    );
  let leg_ID =
    getValue(legislationList, `length`, 0) > 0 &&
    legislationList.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `legislation_id`, "")
    );
  let rule_ID =
    getValue(ruleList, `length`, 0) > 0 &&
    ruleList.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `legislation_rule_id`, "")
    );

  const handleChangeActiveStatus = async (value: string) => {
    try {
      let resp = await UpdateBulkStatusCheckpointPECompliance({
        ids: selectedIDs,
        is_active: value === "active" ? true : false,
      });
      if (resp) {
        toast.success(getValue(resp, `message`, ""));
        setSelectedIDs([]);
        getData();
      } else {
        getData();
      }
    } catch (error) {}
  };
  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());
  const [check, setCheck] = useState(false);
  const handleRemoveNavItems = () => {
    setCheck(!check);
    setSelectedIDs([]);
  };

  /* -------------------------------------------------------------------------- */
  /*                              Navigation Routes                             */
  /* -------------------------------------------------------------------------- */

  const handleNavigate = (route: string) => {
    if (route === "release-to-vendor") {
      let payload: any = {
        checkpoint_id: selectedIDs,
      };
      let queryRequest = QueryRequestHelper(payload);
      navigate(`/checkpoint/${route}?${queryRequest}`);
    }
  };

  return (
    <DashboardLayout
      permissions={getValue(props, `tabPermissionList`, [])}
      subTabPermissionList={getValue(props, `subTabPermissionList`, [])}
    >
      {!isLoading &&
      !getValue(props, `subTabPermissionList`, []).includes(
        "repository_checkpoint_pe_compliance"
      ) ? (
        <NoAccessPage />
      ) : (
        <>
          {getValue(selectedIDs, `length`, 0) > 0 && (
            <NavigationBar
              selectedIDs={selectedIDs}
              isMarkInactiveSectionVisible={true}
              handleChangeActiveStatus={handleChangeActiveStatus}
              text={"MARK INACTIVE"}
              handleRemoveNavItems={handleRemoveNavItems}
              handleNavigate={handleNavigate}
              multi
              confure
              confureModal={handleModal}
              permissions={props.permissions}
            />
          )}
          <div className="dashboard-wrapper__header d-none">
            <h4 className="dashbaord-wrapper__header-title">PE Compliance</h4>
          </div>

          <div className="dashboard-wrapper__header d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center">
              <div className="header-parent-icon-holder">
                <MenuRepositorySvgComponent />
              </div>

              <div className="title-wrapper">
                <h6 className="dashbaord-wrapper__header-parent-title">
                  Checkpoint
                </h6>
                <h4 className="dashbaord-wrapper__header-title">PE Compliance</h4>
              </div>
            </div>

            <div className="d-flex align-items-center">
              <RightMenuHeaders
                monthYear={false}
                
                //search
                isSearch={true}
                searchInput={search_text}
                showSearchTextbox={showSearchTextbox}
                toggleSearch={toggleSearch}
                toggleSearchClose={toggleSearchClose}
                handleChangeSearch={handleChangeSearch}
                //smartFilter
                smartFilter={true}
                handleFilter={handleFilter}

                //Line Seperator of button
                lineSeperator={false}
                selectedFilterCount={countKeysWithValues(params)}
              />
            </div>
          </div>
          
          <div className={`main-page-layout-wrapper has-module-filter`} id={getValue(selectedIDs, `length`, 0) > 0
					? "blueNavigationVisible"
					: ""}>
            <div className="admin-wrapper position-relative">
              <div className="admin-wrapper position-relative d-none">
                <SearchHeader
                  route={"/support/details"}
                  searchInput={search_text}
                  showSearchTextbox={showSearchTextbox}
                  toggleSearch={toggleSearch}
                  toggleSearchClose={toggleSearchClose}
                  handleChangeSearch={handleChangeSearch}
                  isBulkUploadVisible={false}
                  smartFilter={true}
                  setFilterFormVisibility={() => {
                    setFilterVisibility(!isFilterVisible);
                  }}
                  add={"false"}
                  isFilterVisible={isFilterVisible}
                  filter
                  filterList={[
                    { value: "configured", label: "Configured" },
                    { value: "not_configured", label: "Not Configured" },
                  ]}
                  filterLocation
                  locationList={locationList}
                  handleChangeStatus={handleChangeStatus}
                  handleTriggerLocation={handleTriggerLocation}
                  searchLoading={searchLoading}
                  filterFrequency
                  frequencyList={frequencyList}
                  handleTriggerFrequency={handleTriggerFrequency}
                  searchFrequencyLoading={searchFrequencyLoading}
                  filterIsOpen={filterIsOpen}
                  handleFilter={() => {
                    setFilterIsOpen(!filterIsOpen);
                  }}
                />
              </div>
              
              <div>
                <ModuleFilter
                filter
                filterList={[
                  { value: "configured", label: "Configured" },
                  { value: "not_configured", label: "Not Configured" },
                ]}
                filterLocation
                locationList={locationList}
                handleChangeStatus={handleChangeStatus}
                handleTriggerLocation={handleTriggerLocation}
                searchLoading={searchLoading}
                filterFrequency
                frequencyList={frequencyList}
                handleTriggerFrequency={handleTriggerFrequency}
                searchFrequencyLoading={searchFrequencyLoading}
                  
                />
              </div>
              {/* {isFilterVisible && ( */}
                <FilterForm
                  setFilterFormVisibility={() => {
                    setFilterVisibility(!isFilterVisible);
                  }}
                  countryList={countryList}
                  states={states}
                  handleChangeSelect={handleChangeSelect}
                  country_ID={country_ID}
                  state_ID={state_ID}
                  reset={reset}
                  handleSubmitSmartFilter={handleSubmitSmartFilter}
                  additionalFilter={true}
                  smartFilterList={smartFilterList}
                  handleChangeSelectMulti={handleChangeSelectMulti}
                  selectedSmartFilterIds={selectedSmartFilterIds}
                  request={request}
                  //dynamic filter ( Custom Input Select Dropdown)
                  //----> category of law
                  categoryOfLawList={categoryOfLawList}
                  getCategoryLawList={getCategoryLawList}
                  categoryLawLoading={categoryLawLoading}
                  cat_ID={cat_ID}
                  //----> legislation
                  legislationList={legislationList}
                  getLegislationList={getLegislationList}
                  legislationLoading={legislationLoading}
                  leg_ID={leg_ID}
                  //----> legislation rule
                  ruleList={ruleList}
                  getLegislationRuleList={getLegislationRuleList}
                  rule_ID={rule_ID}
                  legislationRuleLoading={legislationRuleLoading}
                  resetInput={resetInput}
                  filterIsOpen={filterIsOpen}
                  handleFilter={handleFilter}
                  moduleName={"Checkpoint"}
								  subModuleName={"PE Compliance"}
                />
              {/* )} */}
              {/* <AddFilter
                  isFilterVisible={isFilterVisible}
                  isFilterHeadingVisible={true}
                  isFilterSubHeadingVisible={true}
                  isBulkUploadVisible={true}
                  addButtonLink={'/checkpoint/active-detail'}
                  setFilterFormVisibility={() => {
                  setFilterVisibility(!isFilterVisible);
                  }}
                />
                */}
              {isLoading || !props.permissionAPITriggered ? (
                <Loader />
              ) : list.length > 0 ? (
                <ScrollableReactTable
                  columns={columns}
                  data={list}
                  getTableState={getTableState}
                  rowClick={rowClick}
                  check={check}
                  selectedIDs={selectedIDs}
                  getTrProps={getTrProps}
                />
              ) : (
                <>
                  {Object.keys(params).length !== 0 ? (
                    <>
                      <CheckpointLicenseNotfound />
                    </>
                  ) : (
                    <CheckpointLicenseNotfound />
                  )}
                </>
              )}
            </div>

            <FooterWrapper
              list={list}
              totalCount={totalCount}
              limit={limit}
              page_no={page_no}
              handleChangePagination={handleChangePagination}
              handleChangeLimit={handleChangeLimit}
            />
          </div>
          <DeleteModal
            isOpen={isDelete}
            handleModal={handleDelete}
            handleSubmit={handleDeleteFunction}
            deleteValue={deleteValue}
          />
          <ConfigurePopup
            isOpen={isOpen}
            handleModal={handleModal}
            selectedIDs={selectedIDs}
            handleModalCancel={handleModalCancel}
            getDataRefetch={getDataRefetch}
            configureID={configureID}
            setConfigureID={setConfigureID}
          />
        </>
      )}
    </DashboardLayout>
  );
};

export default ClientPECompliance;
